import React from 'react';

import './styles.css';

import { Link } from 'react-router-dom';
import { FaAngleRight } from 'react-icons/fa';

export default function HomeCard(props) {
  return (
    <Link to={props.to} className='home-card'>
      <div className='home-card-tittle'>
        <p>{props.title}</p><FaAngleRight />
      </div>
      <div className='home-card-data'>
        <p>{props.data}</p>
        {props.icon}
      </div>
    </Link>
  )
}